let cartDrawerContent = document.querySelectorAll(".cart-loop");

//Clear Cart
const clearCart = function () {
  cartDrawerContent.forEach(function(item){
    item.innerHTML = "";
  })
};

//Cart Count
const countCartItems = function (cart) {
  //console.log(cart);

  let cartCounters = document.querySelectorAll('.cart-count');
  let cartBlock = document.querySelectorAll('.cart-block');

  cartCounters.forEach(function(item){
    item.innerText = cart.item_count;
  });

  let cartTotal = document.querySelectorAll(".cart-total");
  // let formatTotal = Shopify.formatMoney(cart.original_total_price);
  // let splitTotal = formatTotal.split(".");

  // cartTotal.forEach(function(item){
  //   item.innerText = splitTotal[0];
  // });

  let totalPrice = cart.original_total_price / 100;
  let symbol = window.currencySymbol || '$';
  
  let formatTotal =
    Number.isInteger(totalPrice)
      ? `${symbol}${totalPrice.toFixed(0)}`
      : `${symbol}${totalPrice.toFixed(2)}`;
  
  cartTotal.forEach(function(item){
    item.innerText = formatTotal;
  });

  if (cart.item_count == 0) {
    cartBlock.forEach(function (item) {
      item.classList.add("empty");
    });
  } else {
    cartBlock.forEach(function (item) {
      item.classList.remove("empty");
    });
  }
};

//Render Cart
const renderCart = function (cart) {
  //console.log(cart);
  let memberStatus = document.querySelector('#side-cart').dataset.status;
  document.querySelector('#side-cart').dataset.memberSavings = 0;
  //console.log(memberStatus);
  
  cart.items.forEach(function (item, index) {
    //console.log(item);

    //Image
    let pImage = '<a href="' + item.url + '"><img src="' + item.image + '"/></a>';

    //Price
    //let dirtyPrice = item.line_price;
    //let formatPrice = Shopify.formatMoney(item.line_price);
    //let formatPrice = Shopify.formatMoney(item.line_price, Shopify.money_format);
    //let splitPrice = formatPrice.split('.');


    //let pPrice = '<p class="price ag">' + splitPrice[0] + '</p>';

    let symbol = window.currencySymbol || '$';
    let price = item.line_price / 100;
    
    let formatPrice =
      Number.isInteger(price)
        ? `${symbol}${price.toFixed(0)}`
        : `${symbol}${price.toFixed(2)}`;
    

    //console.log(symbol);

    let pPrice = '<p class="price ag">' + formatPrice + '</p>';


    //Title
    let trimTitle = item.product_title.split(" - ");
    let pTitle = '<p class="title ag"><a href="' + item.url + '">' + trimTitle[0] + '<span class="final-sale"></span></a></p>';

    //Notifications
    let pNotification = '<p class="type ag"></p>';

    //Color
    let pColor = "";

    if (item.handle == "membership-program-yearly-recurring" || item.handle == "membership-program-non-recurring" || item.handle == "membership-program-complimentary" || item.handle == 'pay-now-to-unlock-free-returns') {
      pColor = "";
    } else {
      pColor = '<p class="color ag">Color: ' + trimTitle[1] + "</p>";
    }

    //Size
    let sizeCheck = item.options_with_values[0].value.toString();
    let pSize = "";

    if (sizeCheck == "Default Title") {
      pSize = "";
    } else {
      pSize = '<p class="size ag">Size: ' + sizeCheck + "</p>";
    }

    //Quantity

    let pQuantity = "";

    if (item.handle == 'pay-now-to-unlock-free-returns') {
    } else {
      pQuantity = '<p class="quantity ag">Quantity: ' + item.quantity + "</p>";
    }

    //let pQuantity = '<p class="quantity ag">Quantity: ' + item.quantity + "</p>";

    //Remove
    let pRemove = '<a class="remove-btn ag" href="#">Remove</a>';
    //let pRemove = '<p>' + cartVars.removeFromCartNoDot + '</p>';

    let pPreOrder = '<span class="pre-order ag"></span>';

    //Right Side of Product
    let pInfo ='<li class="item" data-line="' + Number(index + 1) + '" data-qty="' + item.quantity + '">' + '<div class="left">' + pImage + "</div>" + '<div class="right">' + pNotification + pTitle + pPrice + '<div class="variants"></div>' + pColor + pSize + pQuantity + pPreOrder + pRemove + '</div></li>';

    cartDrawerContent.forEach(function (ctem) {
      ctem.innerHTML = ctem.innerHTML + pInfo;
    });
    
    //Tags
    let dirtyName = "/products/" + item.handle + ".js";

    var xhr = new XMLHttpRequest();
    xhr.open("GET", dirtyName, true);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 400) {
        let product = JSON.parse(xhr.responseText);
        let cartLoop = document.querySelector("#side-cart");
        
        let onSale = false;
        let finalSale = false;
        let qtyDirty = cartLoop.querySelectorAll(".quantity")[index].innerText;
        let match = qtyDirty.match(/\d+/);
        let qty = parseInt(match[0]);
        let comparePrice = product.compare_at_price * qty;
        let productPrice = product.price * qty;
        let splitFull;

        let memberStatus = cartLoop.dataset.memberStatus;
        let isMember = false;
        let hasEssentials = false;
        let itemMemberSavings = 0;
        let pTags = product.tags;


        if(memberStatus == "member"){
          isMember = true;
        }

        pTags.forEach(function (tag) {
          let tagString = tag.toString();
          if (tagString.includes("essentials") || tagString.includes("exclusives")) {
            hasEssentials = true;
          }
        });

        if (comparePrice > productPrice) {
          onSale = true;
          //console.log(product.title + " is on sale");
        }

        if (onSale) {
          let savings = ((comparePrice - productPrice) / comparePrice) * 100;
          if(savings >= 69){
            finalSale = true;
          }

          let fullPrice = Shopify.formatMoney(comparePrice);
          splitFull = fullPrice.split(".");

          let salePrice = Shopify.formatMoney(productPrice);
          let splitSale = salePrice.split(".");
          cartLoop.querySelectorAll(".price")[index].innerHTML = "<s>" + splitFull[0] + "</s>" + splitSale[0];
        }

        if (hasEssentials) {
          let cartMemberUpsellBlock = document.querySelector('#cart-member-upsell');
          if(cartMemberUpsellBlock){
            cartMemberUpsellBlock.classList.add('active');
          }

          //Set member savings
          itemMemberSavings = productPrice * .20;
          let currentMemberSavings = parseInt(cartLoop.dataset.memberSavings);
          cartLoop.dataset.memberSavings = currentMemberSavings + itemMemberSavings;

          let memberSavings = parseInt(cartLoop.dataset.memberSavings);
          let savingsTotalDirty = Shopify.formatMoney(memberSavings);
          let savingsTotalSplit = savingsTotalDirty.split(".");
          //console.log(savingsTotalSplit[0]);

          let memberSavingsCon = document.querySelectorAll(".member-savings");
          memberSavingsCon.forEach(function(item){
            item.innerHTML = savingsTotalSplit[0];
          });
        }

        pTags.forEach(function (tag) {
          let tagString = tag.toString();
          if (tagString.includes("essentials")) {
            if(finalSale){
              cartLoop.querySelectorAll(".type")[index].innerHTML = "Essentials -  Final Sale";
            } else {
              cartLoop.querySelectorAll(".type")[index].innerHTML = "Essentials";
            }
          } else if(finalSale){
            cartLoop.querySelectorAll(".type")[index].innerHTML = "Final Sale";
          }
          if(onSale){
            let salePrice = Shopify.formatMoney(productPrice);
            let splitSale = salePrice.split(".");
            //cartLoop.querySelectorAll(".price")[index].innerHTML = splitSale[0];
            //console.log(splitSale[0]);
          }
          if(tagString.includes('pre-order')){
            cartLoop.querySelectorAll(".type")[index].innerHTML = "Pre-Order";
          }
        });
      }
    };

    xhr.send();    
  });

  cartDrawerContent.forEach(function(rtem){
    let removeBtn = rtem.querySelectorAll(".remove-btn");
    removeBtn.forEach(function(stem, s){
      stem.addEventListener("click", function (event) {
        event.preventDefault();
        let line = this.parentNode.parentNode.getAttribute("data-line");
        //console.log(line);
        let currentIndexer = s;
        changeItem(line, currentIndexer);
      });
    });
  });

};

//Post Cart Check
const postCartCheck = function(cart){
  //console.log(cart);
  let memberStatus = document.querySelector('#side-cart').dataset.status;
  let memberTotal = document.querySelector('#member-total');
  let formatMember = Shopify.formatMoney(cart.total_price);
  let splitMember = formatMember.split(".");
  if(memberTotal){
    memberTotal.innerText = splitMember[0];
  }

  let tempMemberCheck = false;
  let upsellCon = document.querySelectorAll(".upsell");

  cart.items.forEach(function (item) {
    if (item.handle == "membership-program-non-recurring" || item.handle == "membership-program-yearly-recurring") {
      tempMemberCheck = true;
    }
  });


  if (tempMemberCheck) {
    cart.items.forEach(function (item, i) {
      let dirtyName = "/products/" + item.handle + ".js";

      var xhr = new XMLHttpRequest();
      xhr.open("GET", dirtyName, true);
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 400) {
          let product = JSON.parse(xhr.responseText);  
          //console.log(product);
          let cartLoop = document.querySelector("#side-cart");
          let pTags = product.tags;
          let isEssential = false;

          pTags.forEach(function (tag) {
            let tagString = tag.toString();
            if (tagString.includes("essentials") || tagString.includes("exclusives")) {
              isEssential = true;
            }
          });

          if(isEssential){
            let dirtyPriceCon = cartLoop.querySelectorAll(".price")[i];
            let dirtyPrice = dirtyPriceCon.innerText;
            //console.log(dirtyPrice);
            let commaCheck = dirtyPrice.replace(/,/g, '');
            let dirtyMatch = commaCheck.match(/\d+/g);
            let dirtyInt = parseInt(dirtyMatch[0]);

            let dirtyRetailPrice = dirtyInt / (1 - .20) * 100;
            let retailPrice = Shopify.formatMoney(dirtyRetailPrice);
            let splitRetail = retailPrice.split(".");
            let memberBase = 0;
            let memberSale = 0;
            let memberSaleFormat = Shopify.formatMoney(memberSale);
            let memberSaleSplit = "";

            if(product.compare_at_price > product.price){
              let dirtyStart = dirtyPriceCon.innerHTML.replace(/<s>(.*?)<\/s>/g, '');
              let dirtyComma = dirtyStart.replace(/,/g, '');
              let dirtyNumbers = dirtyComma.match(/\d+/g);
              let dirtyInt = parseInt(dirtyNumbers[0]);
              memberBase = dirtyInt * 100;
              memberSale = memberBase - (memberBase * .20);
              memberSaleFormat = Shopify.formatMoney(memberSale);
              memberSaleSplit = memberSaleFormat.split(".");
              dirtyPriceCon.innerHTML = '<s>' + dirtyStart + '</s>' + memberSaleSplit[0];
              //console.log(dirtyStart);
              //console.log(dirtyInt);
              // memberBase = dirtyInt * 100;
              // memberSale = memberBase - (memberBase * .20);
              // memberSaleFormat = Shopify.formatMoney(memberSale);
              // memberSaleSplit = memberSaleFormat.split(".");
              //dirtyPriceCon.innerHTML = '<s>' + dirtyPrice + '</s>' + memberSaleSplit[0];
            } else { 
              dirtyPriceCon.innerHTML = '<s>' + splitRetail[0] + '</s>' + dirtyPrice;
            }
          }

        }
      }

      xhr.send(); 
    });


    upsellCon.forEach(function (ktem) {
      ktem.classList.add("hide");
    });
    document.querySelector('#member-total-block').classList.add('show');
  } else {
    upsellCon.forEach(function (ktem) {
      ktem.classList.remove("hide");
    });
    if(memberStatus == "member"){
      //console.log("Is Member");

      cart.items.forEach(function (item, i) {
        let dirtyName = "/products/" + item.handle + ".js";

        var xhr = new XMLHttpRequest();
        xhr.open("GET", dirtyName, true);
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 400) {
            let product = JSON.parse(xhr.responseText);  
            //console.log(product);
            let cartLoop = document.querySelector("#side-cart");
            let pTags = product.tags;
            let isEssential = false;

            pTags.forEach(function (tag) {
              let tagString = tag.toString();
              if (tagString.includes("essentials") || tagString.includes("exclusives")) {
                isEssential = true;
              }
            });

            if(isEssential){
              let dirtyPriceCon = cartLoop.querySelectorAll(".price")[i];
              let dirtyPrice = dirtyPriceCon.innerText;
              let commaCheck = dirtyPrice.replace(/,/g, '');
              let dirtyMatch = commaCheck.match(/\d+/g);
              let dirtyInt = parseInt(dirtyMatch[0]);

              let discount = dirtyInt * .2;
              let discountPrice = dirtyInt - discount;
              let discountDirtyPrice = discountPrice * 100;

              let discountFullPrice = Shopify.formatMoney(discountDirtyPrice);
              let splitDiscountFull = discountFullPrice.split(".");
              dirtyPriceCon.innerHTML = '<s>' + dirtyPrice + '</s>' + splitDiscountFull[0];
              //console.log(discountPrice);

            //   let retailPrice = Shopify.formatMoney(dirtyRetailPrice);
            //   let splitRetail = retailPrice.split(".");
              
            //   dirtyPriceCon.innerHTML = '<s>' + splitRetail[0] + '</s>' + dirtyPrice;
            }

          }
        }

        xhr.send(); 
      });
      let memberTotalBlock = document.querySelector('#member-total-block');
      if(memberTotalBlock){
        document.querySelector('#member-total-block').classList.add('show');
      }
    } else {
      //console.log("Not Member");
      let memberTotalBlock = document.querySelector('#member-total-block');
      if(memberTotalBlock){
        document.querySelector('#member-total-block').classList.remove('show');
      }
    }
  }
}

//Display Cart in Side Cart
const displayCart = function () {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", "/cart.js", true);
  xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 400) {
      var cartData = JSON.parse(xhr.responseText);
      clearCart();
      countCartItems(cartData);
      renderCart(cartData);
      postCartCheck(cartData);
    }
  };

  xhr.send();
};

//Change Quantity
const changeItem = function (line, callback) {
  let quantity = 0;
  var xhr = new XMLHttpRequest();
  xhr.open("POST", "/cart/change.js", true);
  xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 400) {
      var cartData = JSON.parse(xhr.responseText);
      countCartItems(cartData);
      if (typeof callback === "function") {
        callback(cartData);
      } else {
        clearCart();
        displayCart();
      }
    }
  };

  xhr.send("quantity=" + quantity + "&line=" + line);
};

displayCart();

// document.addEventListener('DOMContentLoaded', function () {
//   const originalFetch = window.fetch;

//   // Override the fetch API to detect add-to-cart actions
//   window.fetch = async function (url, options) {
//     if (url.includes('/cart/add.js') && options?.method === 'POST') {
//       const response = await originalFetch.apply(this, arguments);
//       if (response.ok) {
//         // Item added successfully, call renderCart()
//         displayCart();
//       }
//       return response;
//     }
//     return originalFetch.apply(this, arguments);
//   };
// });